import { useEffect, useRef } from 'react'
import { useAppDispatch, useAppSelector } from 'reduxTyped'

import { NodePreloaderRules } from 'common/builder/components/chart/FlowChart/adapters/node.preloader.rules'
import { DefaultDataPreloadManager } from 'common/builder/components/chart/FlowChart/lib/DefaultDataPreloadManager'
import { PredicatePreloader } from 'common/builder/components/chart/FlowChart/lib/PredicatePreloader'
import {
  DataPreloadManager,
  NodePreloadRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import * as entitySelectors from 'common/builder/selectors/builder/entitySelectors'
import { getPermissions } from 'common/userRoles/selectors/userRolesSelectors'

export const useFlowChartDataPreloader = ({ builderId }: { builderId: string }) => {
  const predicatePreloader = useRef<PredicatePreloader>()
  const dataPreloadManager = useRef<DataPreloadManager>()
  const dispatch = useAppDispatch()

  const { nodesList, blocks, permissions } = useAppSelector((state) => ({
    nodesList: entitySelectors.getNodesList(state, builderId),
    blocks: entitySelectors.getBlocksMap(state, builderId),
    permissions: getPermissions(state),
  }))

  useEffect(() => {
    if (!dataPreloadManager.current) {
      dataPreloadManager.current = new DefaultDataPreloadManager()
    }

    if (!predicatePreloader.current) {
      predicatePreloader.current = new PredicatePreloader(dataPreloadManager.current)
    }

    const payload: NodePreloadRulePayload = {
      blocks,
      builderId,
      permissions,
      dispatch,
    }

    predicatePreloader.current?.preloadDataForEntities({
      entities: nodesList,
      rules: NodePreloaderRules,
      payload,
    })
  }, [blocks, builderId, dispatch, nodesList, permissions])
}
